export default __webpack_public_path__ + "static/media/007-pregnancy.2f292c63.svg";